import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { IApplication } from '@app/core/model/applications/applications';
import { NgxSmartModalService } from '@bssh/comp-lib';
import { AgreementCategory, AgreementStatus } from '@root/src/app/core/model/user-agreements/user-agreements';
import { BaseModalComponent, ModalComponentType } from '@root/src/app/shared/modals/base-modal/base-modal.component';
import { IAppAgreementModalInput, IAppEulaModalOutput } from '@root/src/app/shared/modals/model/action-modal';
import { RadBaseModalComponent } from '../rad-base-modal/rad-base-modal.component';

@Component({
  selector: 'app-eula-modal',
  templateUrl: './eula-modal.component.html',
  styleUrls: ['./eula-modal.component.scss']
})
export class EulaModalComponent extends BaseModalComponent implements OnInit, AfterViewInit, OnDestroy {
  modalComponentType = ModalComponentType.RAD;
  modalType = 'EulaModal';
  modalContent;
  modalCloseButtonText;
  modalConfirmButtonText = 'I accept';

  agreementStatus: AgreementStatus;
  agreementCategory: AgreementCategory;
  application: IApplication;

  showConfirmButton: boolean = false;
  isAccepted: boolean = false;

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private element: ElementRef
  ) {
    super(ngxSmartModalService);
  }

  ngOnInit() {
    // Assign modal text content according to input
    this.subs.sink = this.data.subscribe((modalInput: IAppAgreementModalInput) => {
      if (modalInput && modalInput.content && modalInput.title && modalInput.version) {
        this.modalContent = modalInput.content;

        this.agreementStatus = modalInput.status;
        this.showConfirmButton = this.agreementStatus === AgreementStatus.PENDING ? true : false;
        this.modalCloseButtonText = this.agreementStatus === AgreementStatus.PENDING ? 'I decline' : 'Close';

        this.agreementCategory = modalInput.category;

        this.application = modalInput.application;
      }
    });
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();

    if(this.agreementStatus === AgreementStatus.SIGNED) {
      this.appendAcceptedAgreementText();
    }
  }

  private appendAcceptedAgreementText(): void {
    const element = this.element.nativeElement;
    const closeButtonElement = element.querySelector('.modal-dialog__footer');

    const acceptedDiv = document.createElement('div');
    acceptedDiv.classList.add('modal-dialog__footer--item');
    acceptedDiv.innerHTML = `
      <div>You have already accepted this license agreement</div>
    `;

    closeButtonElement.prepend(acceptedDiv);
  }

  close(modal: RadBaseModalComponent) {
    const modalOutput: IAppEulaModalOutput = { isAccepted: this.isAccepted };
    this.confirm.emit(modalOutput);
    this.confirm.complete();
  }

  /**
   * Override BaseModalComponent's accept(). Called when the confirm
   * button on modal is clicked to proceed with the action.
   * Sets isProceed to true to be emitted on close.
   * @param modal modal instance emitted as $event from eventEmitter
   */
  accept(modal: RadBaseModalComponent) {
    this.isAccepted = true;
    modal.close();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
